import Vue from 'vue'
import VueRouter from 'vue-router'
import guards from '../middleware';
import Main from '@/components/Main'
// import Home from '../views/Home.vue'
import FormRegister from '../views/FormRegister.vue'
import Thanks from '../views/Thanks.vue'
import Errors from '../views/Errors.vue'
import MainWSC from '@/components/MainWSC'
import ManageForm from '../views/ManageForm.vue'
import FormCreate from '../views/FormCreate.vue'
import FormUpdate from '../views/FormUpdate.vue'
import ManageUser from '../views/ManageUser.vue'
import ManageLineChannel from '../views/ManageLineChannel.vue'
import ManageFacebookPixel from '../views/ManageFacebookPixel.vue'
import ManageThanks from '../views/ManageThanks.vue'
import Test from '../views/Test.vue'
import FormPreview from '../views/FormPreview.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path:'/login', 
      name: 'login', 
      component: Login, 
      beforeEnter: guards.isLogin,
    },
    {
      path: '/',
      name: '',
      component: Main,
      children: [
        // {
        //   path: 'S01',
        //   name: 'registerform',
        //   component: RegisterForm
        // },
        {
          path: 'register',
          name: 'formregister',
          component: FormRegister
        },
        {
          path: 'thanks',
          name: 'thanks',
          component: Thanks
        },
        {
          path: 'errors',
          name: 'errors',
          component: Errors
        },
        {
          path: 'preview',
          name: 'preview',
          component: FormPreview
        },
      ],
    },
    {
      path: '/wsc',
      name: 'wsc',
      component: MainWSC,
      // beforeEnter: Guards.isAuth,
      children: [
        {
          path: 'manageform',
          name: 'manageform',
          component: ManageForm,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'formupdate',
          name: 'formupdate',
          component: FormUpdate,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'formcreate',
          name: 'formcreate',
          component: FormCreate,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'manageuser',
          name: 'manageuser',
          component: ManageUser,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'managelinechannel',
          name: 'managelinechannel',
          component: ManageLineChannel,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'managefacebookpixel',
          name: 'managefacebookpixel',
          component: ManageFacebookPixel,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'managethanks',
          name: 'managethanks',
          component: ManageThanks,
          beforeEnter: guards.isAuth,
        },
        {
          path: 'test',
          name: 'test',
          component: Test,
          // beforeEnter: Guards.isAuth,
        },
      ]
    }
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/',
  routes
})

export default router
